import { render } from "./SettingsAttachmentsFolder.vue?vue&type=template&id=9abe5fa0"
import script from "./SettingsAttachmentsFolder.vue?vue&type=script&lang=js"
export * from "./SettingsAttachmentsFolder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__